// extracted by mini-css-extract-plugin
module.exports = {"ingress":"Ingress_ingress__1tiex"};